<template>
  <div class="container">
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="title-single-box"><h1 class="title-single">Press</h1><span
              class="color-text-a">LASR Lab - Vanderbilt University Medical Center</span></div>
          </div>
          <div class="col-md-12 col-lg-4">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/" class="router-link-active">Home</a></li>
                <li aria-current="page" class="breadcrumb-item active">
                  Press
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="section-press">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-t1">
            <div class="row">
              <div class="col-md-12">
                <ul>
                  <li v-for="l in links">
                    <a :href="l.link" target="_blank">{{l.title}}</a> ({{l.date}})
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Press",
    data: function () {
      return {
        links: [{
          link: "https://www.healthline.com/health-news/indications-of-autism-may-be-revealed-during-fetal-mri-scans",
          title: "Indications of Autism May Be Revealed During Fetal MRI Scans",
          date: "April 2022"
        }, {
          link: "https://open.spotify.com/episode/5rJRlsU0v8bK4EdxutBbVx",
          title: "Spotify - The BrainCore Podcast - Episode 3: Chamber of Isolation (with Dr. Carissa Cascio)",
          date: "Oct 2020"
        }, {
          link: "https://notables.vkcsites.org/2020/09/2020-pat-summitt-award-funds-slated-to-support-vanderbilt-kennedy-center-autism-research/",
          title: "2020 Pat Summitt Award funds slated to support Vanderbilt Kennedy Center autism research",
          date: "Sep 2020"
        }, {
          link: "https://www.spectrumnews.org/features/multimedia/webinars/webinar-michelle-failla-and-david-moore-on-pain-in-autism/",
          title: "Webinar: Michelle Failla and David Moore on pain in autism",
          date: "Jul 2020"
        }, {
          link: "https://www.spectrumnews.org/features/multimedia/podcasts/spectrum-stories-social-touch-says-autism/",
          title: "Spectrum Stories: What social touch says about autism",
          date: "Jun 2019"
        }, {
          link: "https://www.spectrumnews.org/features/deep-dive/social-touch-shapes-autism-traits/",
          title: "How ‘social touch’ shapes autism traits",
          date: "May 2019"
        }, {
          link: "https://spectrumnews.org/news/sensory-abnormalities-highlight-early-autism-risk/",
          title: "Our collaborative study of sensory features in high-risk infants, with Dr. Woynaroski and Dr. Goodwin, got some press in Spectrum News after Dr. W. presented the data at SFN",
          date: "Nov 2016"
        }, {
          link: "http://www.theatlantic.com/health/archive/2016/06/sensory-overload/485318/",
          title: "Dr. Cascio is interviewed for an article in The Atlantic magazine about sensory processing in autism, and the controversy over whether sensory processing disorder should be its own diagnosis",
          date: "Jun 2016"
        }, {
          link: "http://www.medscape.com/viewarticle/863484#vp_1\n",
          title: "Dr. Failla's work on pain and self-injurious behavior in ASD is covered in Medscape, part of the WebMD Health Professional Network",
          date: "May 2016"
        }, {
          link: "http://news.vanderbilt.edu/2016/01/autism-study-links-sensory-difficulties-serotonin-system/",
          title: "Kim Schauder's study of tactile defensiveness in ASD and the serotonin system is covered by the Vanderbilt Reporter",
          date: "Jan 2016"
        }, {
          link: "https://spectrumnews.org/news/in-autism-brain-responses-to-pain-dont-match-verbal-ones/",
          title: "Dr. Failla is interviewed by Spectrum News at the Society for Neuroscience Meeting in Chicago about her poster presenting our fMRI study of pain in autism",
          date: "Oct 2015"
        }, {
          link: "http://www.pediatricsconsultant360.com/story/overconnectivity-brain-underlies-sensory-overresponsivity-autism",
          title: "Dr. Cascio is interviewed by Reuters Health about functional connectivity in ASD",
          date: "Jun 2015"
        }, {
          link: "http://www.aboutourkids.org/sirius",
          title: 'Dr. Cascio is a guest on NYU\'s "Doctor Radio" program "About Our Kids," and is interviewed about the lab\'s research on the role of touch in autism',
          date: "Jan 2015"
        }, {
          link: "http://news.vanderbilt.edu/2013/11/autism-narrows-brain-reward-response/",
          title: "The Cascio lab's study of the role of brain reward systems in restricted interests in autism is covered by the Vanderbilt Reporter",
          date: "Nov 2013"
        }, {
          link: "http://http//psychcentral.com/news/2013/05/09/children-with-autism-hypersensitive-to-motion/54637.html",
          title: "Jennifer Foss-Feig's study of visual motion perception in autism covered by Science Daily and Psych Central",
          date: "May 2013"
        }, {
          link: "https://sfari.org/news-and-opinion/conference-news/2012/society-for-neuroscience-2012/famous-rubber-hand-illusion-eludes-children-with-autism",
          title: "Dr. Cascio is interviewed by the Simons Foundation about the rubber hand illusion in autism",
          date: "Nov 2012"
        }, {
          link: "http://pagingdrgupta.blogs.cnn.com/2010/12/02/researchers-one-step-closer-to-potential-autism-test/?iref=allsearch",
          title: "Dr. Cascio is quoted in this CNN article discussing new findings published in the journal Autism Research",
          date: "Dec 2010"
        }]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Press.vue